import { render, staticRenderFns } from "./CalloutList.vue?vue&type=template&id=20cc3976"
import script from "./CalloutList.vue?vue&type=script&lang=js"
export * from "./CalloutList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20cc3976')) {
      api.createRecord('20cc3976', component.options)
    } else {
      api.reload('20cc3976', component.options)
    }
    module.hot.accept("./CalloutList.vue?vue&type=template&id=20cc3976", function () {
      api.rerender('20cc3976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/CalloutList.vue"
export default component.exports